/**
 * Workflow API — history, transition, available.
 */

import { apiFetch } from './core'

export const workflow = {
    history: (params) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/workflow/history?${qs}`)
    },
    transition: (params) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/workflow/transition?${qs}`, { method: 'POST' })
    },
    available: (params) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/workflow/available?${qs}`)
    },
}
